/**
 * 作者：张小彤
 * 时间：2016/12/12
 * 描述：帮助文件
 */

import React, {Component} from 'react';

import './ot.scss';

export default class Help extends Component{
    render(){
        return(
            <div className="tabcon none">
                <div className="helpimg"></div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./D:/front-end-svn/webpack/src/project/sdk/components/ot/ot.jsx